export interface MovieItem {
  id: string;
  title: string;
  type: 'movie' | 'tv' | 'variety';
  year: number;
  rating: number;
  region: string;
  genres: string[];
  director: string;
  actors: string[];
  duration: string;
  cover: string;
  banner: string;
  description: string;
  tags: string[];
  hot: boolean;
  updatedEpisode?: string;
}

export const movies: MovieItem[] = [
  {
    id: 'mv-001',
    title: '星海遗踪',
    type: 'movie',
    year: 2024,
    rating: 8.9,
    region: '中国',
    genres: ['科幻', '冒险'],
    director: '林之航',
    actors: ['周亦辰', '苏晚晴', '陆沉'],
    duration: '132分钟',
    cover: 'https://readdy.ai/api/search-image?query=epic%20chinese%20sci-fi%20movie%20poster%2C%20a%20lone%20astronaut%20standing%20before%20a%20massive%20glowing%20starship%20wreck%20in%20deep%20space%2C%20deep%20navy%20blue%20tones%20with%20warm%20orange%20light%20accents%2C%20cinematic%20dramatic%20lighting%2C%20high%20detail%20digital%20painting%2C%20professional%20movie%20poster%20composition&width=600&height=900&seq=mv001-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=epic%20chinese%20sci-fi%20movie%20scene%2C%20a%20lone%20astronaut%20standing%20before%20a%20massive%20glowing%20starship%20wreck%20in%20deep%20space%2C%20deep%20navy%20blue%20tones%20with%20warm%20orange%20light%20accents%2C%20cinematic%20dramatic%20lighting%2C%20wide%20panoramic%20composition&width=1920&height=1080&seq=mv001-banner&orientation=landscape',
    description: '公元2147年，星际探索队在遥远星域发现一艘失落百年的古老飞船，队长周亦辰带领团队深入未知星海，揭开一段跨越时空的文明秘密。随着探索深入，他们逐渐意识到这艘飞船的秘密远比想象中更加惊人，一场关乎全人类命运的抉择悄然展开。',
    tags: ['星际', '文明', '悬疑', '热血'],
    hot: true,
  },
  {
    id: 'mv-002',
    title: '长夜行歌',
    type: 'movie',
    year: 2024,
    rating: 8.5,
    region: '中国',
    genres: ['剧情', '犯罪'],
    director: '陈墨言',
    actors: ['吴晓川', '何静仪'],
    duration: '118分钟',
    cover: 'https://readdy.ai/api/search-image?query=chinese%20crime%20drama%20movie%20poster%2C%20a%20detective%20in%20a%20rainy%20night%20city%20street%20with%20neon%20reflections%2C%20moody%20dark%20blue%20atmosphere%20with%20amber%20street%20lights%2C%20cinematic%20noir%20style%2C%20professional%20poster%20composition&width=600&height=900&seq=mv002-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=chinese%20crime%20drama%20scene%2C%20a%20detective%20walking%20through%20a%20rainy%20night%20city%20street%20with%20neon%20reflections%2C%20moody%20dark%20blue%20atmosphere%20with%20amber%20street%20lights%2C%20cinematic%20noir%20style&width=1920&height=1080&seq=mv002-banner&orientation=landscape',
    description: '一桩尘封十年的旧案因一封匿名信重启调查，刑警吴队在追查真相的过程中逐渐卷入一张庞大的利益网络，正义与人性在黑夜中反复拉扯。',
    tags: ['悬疑', '反转', '社会'],
    hot: true,
  },
  {
    id: 'mv-003',
    title: '海上花期',
    type: 'movie',
    year: 2023,
    rating: 8.2,
    region: '中国',
    genres: ['爱情', '剧情'],
    director: '沈知意',
    actors: ['林小满', '郑宇辰'],
    duration: '109分钟',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20chinese%20movie%20poster%2C%20a%20couple%20standing%20on%20a%20coastal%20pier%20at%20sunset%2C%20warm%20orange%20golden%20light%20over%20deep%20blue%20ocean%2C%20soft%20emotional%20atmosphere%2C%20professional%20poster%20composition&width=600&height=900&seq=mv003-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=romantic%20chinese%20movie%20scene%2C%20a%20couple%20standing%20on%20a%20coastal%20pier%20at%20sunset%2C%20warm%20orange%20golden%20light%20over%20deep%20blue%20ocean%2C%20soft%20emotional%20atmosphere&width=1920&height=1080&seq=mv003-banner&orientation=landscape',
    description: '异地恋情侣在海边小城重逢，面对时间与距离留下的裂痕，两人决定用一整个夏天重新认识彼此，找回最初心动的理由。',
    tags: ['治愈', '夏日', '青春'],
    hot: false,
  },
  {
    id: 'mv-004',
    title: '铁甲雄狮',
    type: 'movie',
    year: 2024,
    rating: 7.9,
    region: '美国',
    genres: ['动作', '科幻'],
    director: 'Marcus Lee',
    actors: ['Ryan Carter', 'Elena Woods'],
    duration: '142分钟',
    cover: 'https://readdy.ai/api/search-image?query=hollywood%20action%20sci-fi%20movie%20poster%2C%20a%20giant%20mech%20warrior%20standing%20in%20a%20ruined%20futuristic%20city%2C%20deep%20blue%20night%20sky%20with%20orange%20explosion%20light%2C%20epic%20cinematic%20composition&width=600&height=900&seq=mv004-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=hollywood%20action%20sci-fi%20movie%20scene%2C%20a%20giant%20mech%20warrior%20standing%20in%20a%20ruined%20futuristic%20city%2C%20deep%20blue%20night%20sky%20with%20orange%20explosion%20light%2C%20epic%20cinematic%20composition&width=1920&height=1080&seq=mv004-banner&orientation=landscape',
    description: '地球防御计划最后一道防线——机甲驾驶员杰克，必须在外星舰队抵达前完成最后的装甲改造，与队友一同守护人类文明最后的火种。',
    tags: ['机甲', '战争', '热血'],
    hot: true,
  },
  {
    id: 'mv-005',
    title: '花火不眠',
    type: 'movie',
    year: 2023,
    rating: 8.0,
    region: '日本',
    genres: ['剧情', '家庭'],
    director: '小野寺健',
    actors: ['佐藤惠', '中村翼'],
    duration: '115分钟',
    cover: 'https://readdy.ai/api/search-image?query=japanese%20family%20drama%20movie%20poster%2C%20a%20family%20watching%20fireworks%20from%20a%20rooftop%20at%20night%2C%20warm%20orange%20firework%20light%20against%20deep%20blue%20night%20sky%2C%20gentle%20emotional%20tone%2C%20professional%20poster%20composition&width=600&height=900&seq=mv005-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=japanese%20family%20drama%20scene%2C%20a%20family%20watching%20fireworks%20from%20a%20rooftop%20at%20night%2C%20warm%20orange%20firework%20light%20against%20deep%20blue%20night%20sky%2C%20gentle%20emotional%20tone&width=1920&height=1080&seq=mv005-banner&orientation=landscape',
    description: '一场突如其来的离别让三代同堂的家庭重新聚首，在烟花绽放的那个夏夜，他们终于学会如何对彼此说出藏在心底多年的话。',
    tags: ['家庭', '治愈', '催泪'],
    hot: false,
  },
  {
    id: 'mv-006',
    title: '赤焰追凶',
    type: 'movie',
    year: 2022,
    rating: 7.6,
    region: '中国',
    genres: ['动作', '犯罪'],
    director: '韩振宇',
    actors: ['赵天成', '孙丽雅'],
    duration: '121分钟',
    cover: 'https://readdy.ai/api/search-image?query=chinese%20action%20crime%20movie%20poster%2C%20a%20undercover%20cop%20running%20through%20a%20fire-lit%20warehouse%2C%20dramatic%20orange%20flame%20light%20against%20dark%20blue%20shadows%2C%20intense%20cinematic%20composition&width=600&height=900&seq=mv006-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=chinese%20action%20crime%20movie%20scene%2C%20a%20undercover%20cop%20running%20through%20a%20fire-lit%20warehouse%2C%20dramatic%20orange%20flame%20light%20against%20dark%20blue%20shadows%2C%20intense%20cinematic%20composition&width=1920&height=1080&seq=mv006-banner&orientation=landscape',
    description: '卧底警察深入贩毒集团内部多年，在身份即将暴露的最后关头，必须完成一次惊心动魄的绝地反击。',
    tags: ['卧底', '枪战', '紧张'],
    hot: false,
  },
  {
    id: 'tv-001',
    title: '长安医女传',
    type: 'tv',
    year: 2024,
    rating: 9.1,
    region: '中国',
    genres: ['古装', '剧情'],
    director: '柳明珠',
    actors: ['江晚意', '萧景琰', '沈如玉'],
    duration: '共42集',
    updatedEpisode: '更新至28集',
    cover: 'https://readdy.ai/api/search-image?query=chinese%20period%20costume%20drama%20poster%2C%20a%20young%20female%20physician%20in%20ancient%20Tang%20dynasty%20robes%20standing%20in%20a%20palace%20courtyard%2C%20deep%20blue%20and%20warm%20gold%20color%20palette%2C%20elegant%20cinematic%20composition&width=600&height=900&seq=tv001-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=chinese%20period%20costume%20drama%20scene%2C%20a%20young%20female%20physician%20in%20ancient%20Tang%20dynasty%20robes%20standing%20in%20a%20grand%20palace%20courtyard%2C%20deep%20blue%20and%20warm%20gold%20color%20palette%2C%20elegant%20cinematic%20composition&width=1920&height=1080&seq=tv001-banner&orientation=landscape',
    description: '出身医药世家的江晚意女扮男装入宫行医，凭借过人医术周旋于后宫与朝堂之间，卷入一场权谋与爱恨交织的长安往事。',
    tags: ['古装', '权谋', '爱情'],
    hot: true,
  },
  {
    id: 'tv-002',
    title: '都市悬案录',
    type: 'tv',
    year: 2024,
    rating: 8.7,
    region: '中国',
    genres: ['悬疑', '犯罪'],
    director: '方浩然',
    actors: ['齐云舟', '薛凝'],
    duration: '共24集',
    updatedEpisode: '更新至16集',
    cover: 'https://readdy.ai/api/search-image?query=chinese%20urban%20crime%20mystery%20drama%20poster%2C%20a%20detective%20standing%20in%20front%20of%20an%20evidence%20board%20in%20a%20dim%20blue%20lit%20office%20at%20night%2C%20moody%20atmosphere%20with%20orange%20desk%20lamp%20light%2C%20cinematic%20composition&width=600&height=900&seq=tv002-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=chinese%20urban%20crime%20mystery%20drama%20scene%2C%20a%20detective%20standing%20in%20front%20of%20an%20evidence%20board%20in%20a%20dim%20blue%20lit%20office%20at%20night%2C%20moody%20atmosphere%20with%20orange%20desk%20lamp%20light&width=1920&height=1080&seq=tv002-banner&orientation=landscape',
    description: '刑侦支队新任队长齐云舟接手一系列看似无关的连环案件，抽丝剥茧间发现这些案件背后竟指向同一个隐藏多年的秘密组织。',
    tags: ['刑侦', '烧脑', '反转'],
    hot: true,
  },
  {
    id: 'tv-003',
    title: '青春合伙人',
    type: 'tv',
    year: 2023,
    rating: 8.3,
    region: '中国',
    genres: ['青春', '喜剧'],
    director: '梁子墨',
    actors: ['苏小满', '陆屿', '周可可'],
    duration: '共32集',
    updatedEpisode: '已完结',
    cover: 'https://readdy.ai/api/search-image?query=chinese%20youth%20comedy%20drama%20poster%2C%20a%20group%20of%20young%20friends%20laughing%20together%20in%20a%20modern%20startup%20office%2C%20bright%20warm%20orange%20and%20blue%20accent%20lighting%2C%20cheerful%20cinematic%20composition&width=600&height=900&seq=tv003-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=chinese%20youth%20comedy%20drama%20scene%2C%20a%20group%20of%20young%20friends%20laughing%20together%20in%20a%20modern%20startup%20office%2C%20bright%20warm%20orange%20and%20blue%20accent%20lighting&width=1920&height=1080&seq=tv003-banner&orientation=landscape',
    description: '四个性格迥异的年轻人从校园好友变成创业合伙人，在理想与现实的碰撞中，用欢笑和泪水书写属于他们的青春答卷。',
    tags: ['创业', '友情', '励志'],
    hot: false,
  },
  {
    id: 'tv-004',
    title: '边境风云',
    type: 'tv',
    year: 2023,
    rating: 8.6,
    region: '韩国',
    genres: ['动作', '谍战'],
    director: '金宰玹',
    actors: ['朴敏俊', '韩素律'],
    duration: '共20集',
    updatedEpisode: '已完结',
    cover: 'https://readdy.ai/api/search-image?query=korean%20spy%20action%20drama%20poster%2C%20an%20undercover%20agent%20standing%20at%20a%20foggy%20border%20checkpoint%20at%20night%2C%20deep%20blue%20tones%20with%20orange%20warning%20lights%2C%20tense%20cinematic%20composition&width=600&height=900&seq=tv004-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=korean%20spy%20action%20drama%20scene%2C%20an%20undercover%20agent%20standing%20at%20a%20foggy%20border%20checkpoint%20at%20night%2C%20deep%20blue%20tones%20with%20orange%20warning%20lights&width=1920&height=1080&seq=tv004-banner&orientation=landscape',
    description: '国家安全局特工朴敏俊潜入边境走私集团内部，在多方势力的博弈中寻找真正的幕后黑手，一场关乎国家安全的较量悄然打响。',
    tags: ['谍战', '动作', '紧张'],
    hot: true,
  },
  {
    id: 'tv-005',
    title: '厨房里的爱情',
    type: 'tv',
    year: 2024,
    rating: 8.0,
    region: '中国',
    genres: ['爱情', '美食'],
    director: '黄思颖',
    actors: ['林朝夕', '顾北川'],
    duration: '共28集',
    updatedEpisode: '更新至20集',
    cover: 'https://readdy.ai/api/search-image?query=chinese%20romance%20cooking%20drama%20poster%2C%20a%20couple%20cooking%20together%20in%20a%20cozy%20warm%20lit%20restaurant%20kitchen%2C%20warm%20orange%20kitchen%20light%20with%20deep%20blue%20evening%20background%2C%20romantic%20cinematic%20composition&width=600&height=900&seq=tv005-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=chinese%20romance%20cooking%20drama%20scene%2C%20a%20couple%20cooking%20together%20in%20a%20cozy%20warm%20lit%20restaurant%20kitchen%2C%20warm%20orange%20kitchen%20light%20with%20deep%20blue%20evening%20background&width=1920&height=1080&seq=tv005-banner&orientation=landscape',
    description: '米其林主厨顾北川与小餐馆老板林朝夕因一场厨艺比拼结缘，在锅碗瓢盆的烟火气里，两颗心渐渐靠近。',
    tags: ['美食', '甜宠', '轻松'],
    hot: false,
  },
  {
    id: 'tv-006',
    title: '山河如故',
    type: 'tv',
    year: 2022,
    rating: 8.9,
    region: '中国',
    genres: ['古装', '战争'],
    director: '赵景行',
    actors: ['萧长风', '苏云裳'],
    duration: '共46集',
    updatedEpisode: '已完结',
    cover: 'https://readdy.ai/api/search-image?query=chinese%20historical%20war%20drama%20poster%2C%20a%20general%20in%20ancient%20armor%20standing%20on%20a%20mountain%20ridge%20overlooking%20a%20vast%20battlefield%2C%20deep%20blue%20mountain%20mist%20with%20warm%20orange%20sunset%2C%20epic%20cinematic%20composition&width=600&height=900&seq=tv006-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=chinese%20historical%20war%20drama%20scene%2C%20a%20general%20in%20ancient%20armor%20standing%20on%20a%20mountain%20ridge%20overlooking%20a%20vast%20battlefield%2C%20deep%20blue%20mountain%20mist%20with%20warm%20orange%20sunset&width=1920&height=1080&seq=tv006-banner&orientation=landscape',
    description: '乱世之中，年轻将领萧长风率军镇守边关十余载，历经家国破碎与重建，最终守得山河无恙、故人归来。',
    tags: ['战争', '家国', '史诗'],
    hot: false,
  },
  {
    id: 'va-001',
    title: '极限星厨',
    type: 'variety',
    year: 2024,
    rating: 8.4,
    region: '中国',
    genres: ['美食', '竞技'],
    director: '制作组',
    actors: ['多位明星嘉宾'],
    duration: '共12期',
    updatedEpisode: '更新至8期',
    cover: 'https://readdy.ai/api/search-image?query=chinese%20cooking%20competition%20variety%20show%20poster%2C%20chefs%20cooking%20intensely%20in%20a%20bright%20modern%20kitchen%20studio%2C%20vibrant%20orange%20and%20blue%20stage%20lighting%2C%20energetic%20composition&width=600&height=900&seq=va001-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=chinese%20cooking%20competition%20variety%20show%20scene%2C%20chefs%20cooking%20intensely%20in%20a%20bright%20modern%20kitchen%20studio%2C%20vibrant%20orange%20and%20blue%20stage%20lighting&width=1920&height=1080&seq=va001-banner&orientation=landscape',
    description: '八位顶级名厨齐聚一堂，在限定食材与时间的极限挑战中展现厨艺巅峰对决，谁能摘得本季星厨桂冠？',
    tags: ['美食', '竞技', '热血'],
    hot: true,
  },
  {
    id: 'va-002',
    title: '欢乐合唱团',
    type: 'variety',
    year: 2024,
    rating: 8.1,
    region: '中国',
    genres: ['音乐', '综艺'],
    director: '制作组',
    actors: ['多位歌手嘉宾'],
    duration: '共10期',
    updatedEpisode: '更新至6期',
    cover: 'https://readdy.ai/api/search-image?query=chinese%20music%20talent%20variety%20show%20poster%2C%20singers%20performing%20on%20a%20glowing%20stage%20with%20orange%20spotlight%20and%20deep%20blue%20background%2C%20vibrant%20energetic%20composition&width=600&height=900&seq=va002-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=chinese%20music%20talent%20variety%20show%20scene%2C%20singers%20performing%20on%20a%20glowing%20stage%20with%20orange%20spotlight%20and%20deep%20blue%20background&width=1920&height=1080&seq=va002-banner&orientation=landscape',
    description: '来自五湖四海的音乐人组成合唱小队，用歌声打破次元壁，带来一场场充满惊喜的音乐盛宴。',
    tags: ['音乐', '舞台', '治愈'],
    hot: false,
  },
  {
    id: 'va-003',
    title: '荒野求生记',
    type: 'variety',
    year: 2023,
    rating: 8.6,
    region: '中国',
    genres: ['户外', '挑战'],
    director: '制作组',
    actors: ['多位艺人嘉宾'],
    duration: '共14期',
    updatedEpisode: '已完结',
    cover: 'https://readdy.ai/api/search-image?query=outdoor%20survival%20challenge%20variety%20show%20poster%2C%20adventurers%20trekking%20through%20a%20dense%20forest%20at%20dusk%2C%20deep%20blue%20twilight%20with%20warm%20orange%20campfire%20light%2C%20adventurous%20composition&width=600&height=900&seq=va003-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=outdoor%20survival%20challenge%20variety%20show%20scene%2C%20adventurers%20trekking%20through%20a%20dense%20forest%20at%20dusk%2C%20deep%20blue%20twilight%20with%20warm%20orange%20campfire%20light&width=1920&height=1080&seq=va003-banner&orientation=landscape',
    description: '六位嘉宾深入无人岛屿，在断水断粮的极限环境下挑战自我，体验最原始也最真实的生存考验。',
    tags: ['户外', '生存', '挑战'],
    hot: false,
  },
  {
    id: 'va-004',
    title: '脱口秀大会场',
    type: 'variety',
    year: 2024,
    rating: 8.3,
    region: '中国',
    genres: ['脱口秀', '喜剧'],
    director: '制作组',
    actors: ['多位喜剧演员'],
    duration: '共16期',
    updatedEpisode: '更新至10期',
    cover: 'https://readdy.ai/api/search-image?query=chinese%20stand-up%20comedy%20variety%20show%20poster%2C%20a%20comedian%20performing%20on%20stage%20with%20warm%20orange%20spotlight%20against%20dark%20blue%20theater%20backdrop%2C%20lively%20composition&width=600&height=900&seq=va004-cover&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=chinese%20stand-up%20comedy%20variety%20show%20scene%2C%20a%20comedian%20performing%20on%20stage%20with%20warm%20orange%20spotlight%20against%20dark%20blue%20theater%20backdrop&width=1920&height=1080&seq=va004-banner&orientation=landscape',
    description: '新老喜剧人齐聚舞台，用犀利幽默的段子解构生活百态，为观众带来爆笑不断的夜晚。',
    tags: ['喜剧', '脱口秀', '爆笑'],
    hot: true,
  },
];

export const getMovieById = (id: string) => movies.find((m) => m.id === id);

export const getMoviesByType = (type: 'movie' | 'tv' | 'variety') =>
  movies.filter((m) => m.type === type);

export const getHotMovies = () => movies.filter((m) => m.hot);

export const getRelatedMovies = (movie: MovieItem, limit = 4) =>
  movies
    .filter(
      (m) =>
        m.id !== movie.id &&
        (m.type === movie.type ||
          m.genres.some((g) => movie.genres.includes(g)) ||
          m.actors.some((a) => movie.actors.includes(a)))
    )
    .slice(0, limit);